import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  class: "text-center lead",
  style: {"font-size":"1.5rem"}
}
const _hoisted_3 = { class: "card card-collapsable mt-1" }
const _hoisted_4 = {
  id: "cardQuestion",
  class: "card-body collapse show pt-4"
}
const _hoisted_5 = { style: {"min-height":"450px"} }
const _hoisted_6 = { class: "PairwiseComparisonEditor" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-lg-6 col-md-6 col-sm-6 col-xs-12" }
const _hoisted_9 = { class: "mt1 ItemDetailsBox bg-color-blue3" }
const _hoisted_10 = { class: "btn-group ItemButton" }
const _hoisted_11 = { class: "dropdown-menu" }
const _hoisted_12 = { class: "col-lg-6 col-md-6 col-sm-6 col-xs-12" }
const _hoisted_13 = { class: "mt1 ItemDetailsBox bg-color-red3" }
const _hoisted_14 = { class: "btn-group ItemButton" }
const _hoisted_15 = { class: "dropdown-menu" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-lg-6 offset-lg-3 col-md-6 offset-md-3 col-sm-6 offset-sm-3 col-xs-12" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-lg-6 offset-lg-3 col-md-6 offset-md-3 col-sm-6 offset-sm-3 col-xs-12" }
const _hoisted_20 = { style: {"margin-top":"30px"} }
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "mt-3" }
const _hoisted_23 = {
  class: "mt-4",
  style: {"min-height":"500px"}
}
const _hoisted_24 = { class: "PairwiseComparisonVotesBrowserView" }
const _hoisted_25 = { class: "nav nav-tabs" }
const _hoisted_26 = { class: "nav-item" }
const _hoisted_27 = { class: "nav-item" }
const _hoisted_28 = { class: "nav-item" }
const _hoisted_29 = { class: "tab-content" }
const _hoisted_30 = { class: "table-responsive" }
const _hoisted_31 = { class: "table table-striped" }
const _hoisted_32 = {
  class: "clearfix",
  style: {"min-width":"510px","border-top":"0"}
}
const _hoisted_33 = {
  class: "",
  style: {"display":"flex","justify-content":"space-between","align-items":"center","width":"100%"}
}
const _hoisted_34 = {
  class: "pull-left",
  style: {"flex":"1","text-align":"left"}
}
const _hoisted_35 = {
  class: "pull-right",
  style: {"flex":"1","text-align":"right"}
}
const _hoisted_36 = { style: {"text-align":"center"} }
const _hoisted_37 = { style: {"text-align":"left"} }
const _hoisted_38 = { style: {"padding":"0"} }
const _hoisted_39 = {
  class: "clearfix",
  style: {"list-style":"none","margin":"0","padding":"0"}
}
const _hoisted_40 = { style: {"text-align":"center"} }
const _hoisted_41 = { style: {"text-align":"left"} }
const _hoisted_42 = { style: {"padding":"0"} }
const _hoisted_43 = {
  class: "clearfix",
  style: {"list-style":"none","margin":"0","padding":"0"}
}
const _hoisted_44 = { class: "table-responsive" }
const _hoisted_45 = { class: "table" }
const _hoisted_46 = {
  style: {"text-align":"center"},
  class: "bottom noborder"
}
const _hoisted_47 = { style: {"height":"400px","border":"none","padding-top":"20px"} }
const _hoisted_48 = ["innerHTML"]
const _hoisted_49 = { style: {"text-align":"center"} }
const _hoisted_50 = { style: {"width":"6%"} }
const _hoisted_51 = ["colspan"]
const _hoisted_52 = ["colspan"]
const _hoisted_53 = { class: "blockquote" }
const _hoisted_54 = { class: "mb-0" }
const _hoisted_55 = { class: "blockquote-footer" }

import { ref, computed, toRef } from 'vue'

    import { boolCompare, isNullOrWhitespace, numCompare } from '@common/Common'

    import type {
        CriteriaVoteEntry,
        MeetingQuestionReviewReadModel
    } from '@Evaluation/CriteriaSurveys/Domain/readmodels'

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'MeetingQuestionReview',
  props: {
    readModel: {}
  },
  emits: ["update-value", "update-comment", "show-criterion-details"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- shortcuts ----------------

    const rm = toRef(props, 'readModel')

    // ---------------- local state ----------------

    const browserActiveTab = ref<'votes' | 'summary' | 'comments'>('votes')

    const ScaleView1 = [
        9, 8, 7, 6, 5, 4, 3, 2, 1,
        1 / 2, 1 / 3, 1 / 4, 1 / 5, 1 / 6, 1 / 7, 1 / 8, 1 / 9
    ].sort((a, b) => numCompare(a, b))

    // ---------------- basic derived ----------------

    const QuestionId = computed(() => rm.value.Id)
    const ContextName = computed(() => rm.value.ContextCriterionName)
    const FirstItemTitle = computed(() => rm.value.FirstCriterionName)
    const SecondItemTitle = computed(() => rm.value.SecondCriterionName)

    const VotesEntries = computed<CriteriaVoteEntry[]>(() =>
        rm.value.VotesEntries
            ?.sort((a, b) => boolCompare(a.SurveyId != null, b.SurveyId != null))
        ?? []
    )

    const Value = computed<number | null>(() => rm.value.Value)
    const Comment = computed<string | null>(() => rm.value.Comment)

    // ---------------- selection state ----------------

    const EqualitySelected = computed(() => Value.value != null && Value.value === 1.0)
    const FirstSelected = computed(() => Value.value != null && Value.value > 1.0)
    const SecondSelected = computed(() => Value.value != null && Value.value < 1.0)

    const IntegerValue = computed<number | null>(() =>
    {
        if (!Value.value) return null
        const v = Value.value < 1 ? 1 / Value.value : Value.value
        return Math.round(v * 100) / 100
    })

    const FirstBtnLabel = computed(() =>
        FirstSelected.value && IntegerValue.value
            ? `${GetLabel(IntegerValue.value)} (${IntegerValue.value})`
            : 'More important'
    )

    const SecondBtnLabel = computed(() =>
        SecondSelected.value && IntegerValue.value
            ? `${GetLabel(IntegerValue.value)} (${IntegerValue.value})`
            : 'More important'
    )

    // ---------------- aggregation ----------------

    const Average = computed<number | null>(() =>
    {
        const entries = VotesEntries.value.filter(v => v.Value != null && v.VoteStrength > 0)
        if (entries.length < 1) return null

        const sum = entries.reduce((s, v) => s + v.VoteStrength, 0)

        let avg = 1.0
        for (const e of entries)
        {
            avg *= Math.pow(e.Value!, e.VoteStrength / sum)
        }

        return avg
    })

    const Comments = computed(() =>
        VotesEntries.value.filter(v => isNullOrWhitespace(v.Comment) === false)
    )

    const ScaleView = computed(() =>
    {
        const scale = [...ScaleView1]

        if (Average.value != null)
        {
            if (!scale.some(v => Math.round(v * 100) === Math.round(Average.value! * 100)))
            {
                scale.push(Average.value)
            }
        }

        return scale.sort((a, b) => numCompare(a, b)).reverse()
    })

    const LeftScaleValuesCount = computed(() =>
        ScaleView.value.filter(v => v > 1).length
    )

    const RightScaleValuesCount = computed(() =>
        ScaleView.value.filter(v => v < 1).length
    )

    const AverageDescription = computed(() =>
    {
        if (Average.value == null) return 'N/A'
        return Average.value < 1
            ? (1 / Average.value).toFixedIfNeeded(2)
            : Average.value.toFixedIfNeeded(2)
    })

    const HistogramValues = computed(() =>
    {
        const voteValues = VotesEntries.value.filter(v => v.Value != null).map(v => v.Value!)
        const uniqueValues = new Set([...ScaleView1, ...voteValues])
        const orderedValues = Array.from(uniqueValues).sort((a, b) => b - a)

        let maxCount = 0
        for (const value of orderedValues)
        {
            maxCount = Math.max(
                maxCount,
                voteValues.filter(v => v === value).length
            )
        }

        return orderedValues.map(value =>
        {
            const count = voteValues.filter(v => v === value).length
            return {
                Value: value,
                Count: count,
                PercentOfMax: Math.round(count / maxCount * 100)
            }
        })
    })

    // ---------------- actions ----------------

    function SaveValueCommand(value: number | null)
    {
        emit('update-value', value)
    }

    function SaveComment(comment: string)
    {
        emit('update-comment', comment)
    }

    function ShowContextDetailsCommand()
    {
        emit(
            'show-criterion-details',
            rm.value.ContextCriterionName,
            rm.value.ContextCriterionDescription,
            rm.value.ContextCriterionPath
        )
    }

    function ShowFirstItemDetailsCommand()
    {
        emit(
            'show-criterion-details',
            rm.value.FirstCriterionName,
            rm.value.FirstCriterionDescription,
            rm.value.FirstCriterionPath
        )
    }

    function ShowSecondItemDetailsCommand()
    {
        emit(
            'show-criterion-details',
            rm.value.SecondCriterionName,
            rm.value.SecondCriterionDescription,
            rm.value.SecondCriterionPath
        )
    }

    // ---------------- formatting helpers ----------------

    function FormatValue(value: number)
    {
        return value < 1 ? 1 / value : value
    }

    function GetColor(value: number)
    {
        const v = Math.round(value * 100) / 100
        if (v === 1) return 'bg-color-green2'
        if (v > 1) return 'bg-color-blue2'
        return 'bg-color-red2'
    }

    function GetCssClass(scaleValue: number, voteValue: number | null)
    {
        const type = GetScaleItemType(scaleValue, voteValue)

        if (type === 'Empty') return 'EmptyScaleItem'
        if (type === 'Hidden') return 'HiddenScaleItem'

        if (type === 'Filled' || type === 'DoubleFilled')
        {
            return `${type}ScaleItem ${GetColor(voteValue!)}`
        }

        return null
    }

    function GetScaleItemText(scaleValue: number, voteValue: number | null)
    {
        const type = GetScaleItemType(scaleValue, voteValue)
        return type !== 'DoubleFilled'
            ? FormatValue(scaleValue).toLocaleString()
            : FormatValue(voteValue!).toFixedIfNeeded(2)
    }

    function GetLabel(value: number): string
    {
        switch (value)
        {
            case 2: return 'Weakly'
            case 3: return 'Moderately'
            case 4: return 'Moderately +'
            case 5: return 'Strongly'
            case 6: return 'Strongly +'
            case 7: return 'Very Strongly'
            case 8: return 'Very Strongly +'
            case 9: return 'Extremely'
            default: return ''
        }
    }

    function GetScaleItemType(scaleValue: number, voteValue: number | null)
    {
        if (voteValue == null) return 'Empty'

        if (scaleValue < 1 && voteValue > 1) return 'Empty'
        if (scaleValue > 1 && voteValue < 1) return 'Empty'

        let x: number | null = null

        if (scaleValue <= 1 && voteValue <= 1)
            x = (1 / scaleValue) - (1 / voteValue)
        else if (scaleValue >= 1 && voteValue >= 1)
            x = scaleValue - voteValue

        x = Math.round(x! * 100) / 100

        if (x === 0) return 'Filled'
        if (x >= 1 || x <= -1) return 'Empty'
        if (x < 0) return 'Hidden'
        if (x > 0) return 'DoubleFilled'

        return null
    }


return (_ctx: any,_cache: any) => {
  return (rm.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, [
          _cache[22] || (_cache[22] = _createTextVNode(" In the context of ", -1 /* CACHED */)),
          _createElementVNode("a", {
            class: "text-primary",
            onClick: ShowContextDetailsCommand,
            title: "Show details"
          }, _toDisplayString(ContextName.value), 1 /* TEXT */),
          _cache[23] || (_cache[23] = _createTextVNode(", which criterion is more important: ", -1 /* CACHED */)),
          _cache[24] || (_cache[24] = _createElementVNode("br", null, null, -1 /* CACHED */)),
          _createElementVNode("a", {
            class: "text-primary",
            onClick: ShowFirstItemDetailsCommand,
            title: "Show details"
          }, _toDisplayString(FirstItemTitle.value), 1 /* TEXT */),
          _cache[25] || (_cache[25] = _createTextVNode(" or ", -1 /* CACHED */)),
          _createElementVNode("a", {
            class: "text-primary",
            onClick: ShowSecondItemDetailsCommand,
            title: "Show details"
          }, _toDisplayString(SecondItemTitle.value), 1 /* TEXT */),
          _cache[26] || (_cache[26] = _createTextVNode("? ", -1 /* CACHED */))
        ]),
        _createElementVNode("div", _hoisted_3, [
          _cache[34] || (_cache[34] = _createElementVNode("div", {
            class: "card-header pointer",
            "data-toggle": "collapse",
            href: "#cardQuestion"
          }, " Group vote ", -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("h4", null, _toDisplayString(FirstItemTitle.value), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(["btn btn-block dropdown-toggle", FirstSelected.value ? 'btn-success' : 'btn-outline-secondary']),
                        "data-toggle": "dropdown"
                      }, [
                        _createElementVNode("i", {
                          class: _normalizeClass(["fa-regular", FirstSelected.value ? 'fa-square-check' : 'fa-square']),
                          "aria-hidden": "true"
                        }, null, 2 /* CLASS */),
                        _createTextVNode(" " + _toDisplayString(FirstBtnLabel.value), 1 /* TEXT */)
                      ], 2 /* CLASS */),
                      _createElementVNode("div", _hoisted_11, [
                        _cache[27] || (_cache[27] = _createElementVNode("h4", { class: "dropdown-header" }, "How much more important?", -1 /* CACHED */)),
                        _cache[28] || (_cache[28] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (SaveValueCommand(2)))
                        }, "Weak (2)"),
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (SaveValueCommand(3)))
                        }, "Moderate (3)"),
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (SaveValueCommand(4)))
                        }, "Moderate + (4)"),
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (SaveValueCommand(5)))
                        }, "Strong (5)"),
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (SaveValueCommand(6)))
                        }, "Strong + (6)"),
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (SaveValueCommand(7)))
                        }, "Very strong (7)"),
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (SaveValueCommand(8)))
                        }, "Very strong + (8)"),
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (SaveValueCommand(9)))
                        }, "Extreme (9)")
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("h4", null, _toDisplayString(SecondItemTitle.value), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(["btn btn-block dropdown-toggle", SecondSelected.value ? 'btn-success' : 'btn-outline-secondary']),
                        "data-toggle": "dropdown"
                      }, [
                        _createElementVNode("i", {
                          class: _normalizeClass(["fa-regular", SecondSelected.value ? 'fa-square-check' : 'fa-square']),
                          "aria-hidden": "true"
                        }, null, 2 /* CLASS */),
                        _createTextVNode(" " + _toDisplayString(SecondBtnLabel.value), 1 /* TEXT */)
                      ], 2 /* CLASS */),
                      _createElementVNode("div", _hoisted_15, [
                        _cache[29] || (_cache[29] = _createElementVNode("h4", { class: "dropdown-header" }, "How much more important?", -1 /* CACHED */)),
                        _cache[30] || (_cache[30] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (SaveValueCommand(1.0/2.0)))
                        }, "Weak (2)"),
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (SaveValueCommand(1.0/3.0)))
                        }, "Moderate (3)"),
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (SaveValueCommand(1.0/4.0)))
                        }, "Moderate + (4)"),
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          onClick: _cache[11] || (_cache[11] = ($event: any) => (SaveValueCommand(1.0/5.0)))
                        }, "Strong (5)"),
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          onClick: _cache[12] || (_cache[12] = ($event: any) => (SaveValueCommand(1.0/6.0)))
                        }, "Strong + (6)"),
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          onClick: _cache[13] || (_cache[13] = ($event: any) => (SaveValueCommand(1.0/7.0)))
                        }, "Very strong (7)"),
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          onClick: _cache[14] || (_cache[14] = ($event: any) => (SaveValueCommand(1.0/8.0)))
                        }, "Very strong + (8)"),
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          onClick: _cache[15] || (_cache[15] = ($event: any) => (SaveValueCommand(1.0/9.0)))
                        }, "Extreme (9)")
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(["btn btn-block btn-equal mt1", EqualitySelected.value === true ? 'btn-success' : 'btn-outline-secondary']),
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (SaveValueCommand(1.0)))
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(["fa-regular", EqualitySelected.value === true ? 'fa-square-check' : 'fa-square']),
                        "aria-hidden": "true"
                      }, null, 2 /* CLASS */),
                      _cache[31] || (_cache[31] = _createTextVNode(" Equally important (1) ", -1 /* CACHED */))
                    ], 2 /* CLASS */)
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(["btn btn-block mt1", Value.value == null ? 'btn-success' : 'btn-outline-secondary']),
                      onClick: _cache[17] || (_cache[17] = ($event: any) => (SaveValueCommand(null)))
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(["fa-regular", Value.value == null ? 'fa-square-check' : 'fa-square']),
                        "aria-hidden": "true"
                      }, null, 2 /* CLASS */),
                      _cache[32] || (_cache[32] = _createTextVNode(" Follow the average (default) ", -1 /* CACHED */))
                    ], 2 /* CLASS */)
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _cache[33] || (_cache[33] = _createElementVNode("h5", { style: {"margin-bottom":"5px"} }, "Comment:", -1 /* CACHED */)),
                  _createElementVNode("textarea", {
                    rows: "5",
                    value: Comment.value,
                    onInput: _cache[18] || (_cache[18] = ($event: any) => (SaveComment($event.target.value))),
                    class: "form-control",
                    placeholder: "Comment..."
                  }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_21)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("ul", _hoisted_25, [
                _createElementVNode("li", _hoisted_26, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["nav-link", {'active': browserActiveTab.value === 'votes'}]),
                    onClick: _cache[19] || (_cache[19] = ($event: any) => (browserActiveTab.value = 'votes'))
                  }, "Votes", 2 /* CLASS */)
                ]),
                _createElementVNode("li", _hoisted_27, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["nav-link", {'active': browserActiveTab.value === 'summary'}]),
                    onClick: _cache[20] || (_cache[20] = ($event: any) => (browserActiveTab.value = 'summary'))
                  }, "Chart", 2 /* CLASS */)
                ]),
                _createElementVNode("li", _hoisted_28, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["nav-link", {'active': browserActiveTab.value === 'comments'}]),
                    onClick: _cache[21] || (_cache[21] = ($event: any) => (browserActiveTab.value = 'comments'))
                  }, "Comments", 2 /* CLASS */)
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                (browserActiveTab.value === 'votes')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["tab-pane pt-2", {'active': browserActiveTab.value === 'votes'}])
                    }, [
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("table", _hoisted_31, [
                          _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _cache[36] || (_cache[36] = _createElementVNode("th", { style: {"border-top":"0"} }, null, -1 /* CACHED */)),
                              _createElementVNode("th", _hoisted_32, [
                                _createElementVNode("div", _hoisted_33, [
                                  _createElementVNode("div", _hoisted_34, _toDisplayString(FirstItemTitle.value), 1 /* TEXT */),
                                  _cache[35] || (_cache[35] = _createElementVNode("div", {
                                    class: "text-center",
                                    style: {"flex":"1","text-align":"center"}
                                  }, "vs.", -1 /* CACHED */)),
                                  _createElementVNode("div", _hoisted_35, _toDisplayString(SecondItemTitle.value), 1 /* TEXT */)
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("tbody", null, [
                            _createElementVNode("tr", _hoisted_36, [
                              _createElementVNode("td", _hoisted_37, [
                                _createElementVNode("strong", null, "Average (" + _toDisplayString(AverageDescription.value) + ")", 1 /* TEXT */)
                              ]),
                              _createElementVNode("td", _hoisted_38, [
                                _createElementVNode("ul", _hoisted_39, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ScaleView1), (scaleValue) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      class: _normalizeClass(GetCssClass(scaleValue, Average.value))
                                    }, _toDisplayString(GetScaleItemText(scaleValue, Average.value)), 3 /* TEXT, CLASS */))
                                  }), 256 /* UNKEYED_FRAGMENT */))
                                ])
                              ])
                            ]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(VotesEntries.value, (voteEntry) => {
                              return (_openBlock(), _createElementBlock("tr", _hoisted_40, [
                                _createElementVNode("td", _hoisted_41, _toDisplayString(voteEntry.VotesSourceName ?? '???'), 1 /* TEXT */),
                                _createElementVNode("td", _hoisted_42, [
                                  _createElementVNode("ul", _hoisted_43, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ScaleView1), (scaleValue) => {
                                      return (_openBlock(), _createElementBlock("li", {
                                        class: _normalizeClass(GetCssClass(scaleValue, voteEntry.Value))
                                      }, _toDisplayString(GetScaleItemText(scaleValue, voteEntry.Value)), 3 /* TEXT, CLASS */))
                                    }), 256 /* UNKEYED_FRAGMENT */))
                                  ])
                                ])
                              ]))
                            }), 256 /* UNKEYED_FRAGMENT */))
                          ])
                        ])
                      ])
                    ], 2 /* CLASS */))
                  : _createCommentVNode("v-if", true),
                (browserActiveTab.value === 'summary')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass(["tab-pane pt-2", {'active': browserActiveTab.value === 'summary'}])
                    }, [
                      _createElementVNode("div", _hoisted_44, [
                        _createElementVNode("table", _hoisted_45, [
                          _createElementVNode("tbody", null, [
                            _createElementVNode("tr", _hoisted_46, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(HistogramValues.value, (v) => {
                                return (_openBlock(), _createElementBlock("td", _hoisted_47, [
                                  (v.Count)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        innerHTML: v.Count
                                      }, null, 8 /* PROPS */, _hoisted_48))
                                    : _createCommentVNode("v-if", true),
                                  _createElementVNode("div", {
                                    style: _normalizeStyle({'height': `${v.PercentOfMax}%`}),
                                    class: _normalizeClass([GetColor(v.Value), "bg-color-blue2"])
                                  }, " ", 6 /* CLASS, STYLE */)
                                ]))
                              }), 256 /* UNKEYED_FRAGMENT */))
                            ]),
                            _createElementVNode("tr", _hoisted_49, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(HistogramValues.value, (v) => {
                                return (_openBlock(), _createElementBlock("td", _hoisted_50, _toDisplayString(FormatValue(v.Value).toFixedIfNeeded(2)), 1 /* TEXT */))
                              }), 256 /* UNKEYED_FRAGMENT */))
                            ])
                          ]),
                          _createElementVNode("tfoot", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", {
                                colspan: LeftScaleValuesCount.value,
                                style: {"text-align":"left"}
                              }, _toDisplayString(FirstItemTitle.value), 9 /* TEXT, PROPS */, _hoisted_51),
                              _cache[37] || (_cache[37] = _createElementVNode("th", { style: {"text-align":"center"} }, "vs", -1 /* CACHED */)),
                              _createElementVNode("th", {
                                colspan: RightScaleValuesCount.value,
                                style: {"text-align":"right"}
                              }, _toDisplayString(SecondItemTitle.value), 9 /* TEXT, PROPS */, _hoisted_52)
                            ])
                          ])
                        ])
                      ])
                    ], 2 /* CLASS */))
                  : _createCommentVNode("v-if", true),
                (browserActiveTab.value === 'comments')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      class: _normalizeClass(["tab-pane pt-2", {'active': browserActiveTab.value === 'comments'}])
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Comments.value, (c) => {
                        return (_openBlock(), _createElementBlock("blockquote", _hoisted_53, [
                          _createElementVNode("p", _hoisted_54, _toDisplayString(c.Comment), 1 /* TEXT */),
                          _createElementVNode("footer", _hoisted_55, _toDisplayString(c.VotesSourceName ?? '???'), 1 /* TEXT */)
                        ]))
                      }), 256 /* UNKEYED_FRAGMENT */))
                    ], 2 /* CLASS */))
                  : _createCommentVNode("v-if", true)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})